// import { Component, OnInit } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Component, ViewChild, AfterViewInit, NgModule, Inject, OnInit} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable } from '@angular/material/table';
import {merge, Observable, of as observableOf} from 'rxjs';
import {catchError, map, startWith, switchMap} from 'rxjs/operators';
import { BrowserModule } from '@angular/platform-browser';
import { HttpService } from '../../http.service';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MatSnackBar} from '@angular/material/snack-bar';
import { AuthenticationService } from '../../_services';
import { EntradaService } from '../../_services';
import { InventarioService } from '../../_services';
import { first } from 'rxjs/operators';
import {MatButtonModule} from '@angular/material/button';
import { InvoiceService } from '../../_services';
import { Router, ActivatedRoute } from '@angular/router';
import { ShopifyService } from '../../_services';
import { SellerDisconnectService } from 'src/app/_services/seller_disconnect.service';
import { DialogConfirmationComponent } from 'src/app/dialog-confirmation/dialog-confirmation.component';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-integrations',
  templateUrl: './integrations.component.html',
  styleUrls: ['./integrations.component.scss']
})
export class IntegrationsComponent implements OnInit {

  shopi_code: string;
  shopi_shop: string;
  shopi_state: string;
  current_user: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private shopifyService: ShopifyService,
    private authenticationService: AuthenticationService,
    private dialog: MatDialog
  ) { 
    
    
  }

  ngOnInit() {
    this.asignarDatos();
  }
  asignarDatos(){
    this.current_user = this.authenticationService.currentUserValue
    
  }
  validar_roles(clave_modulo){
    return this.authenticationService.validar_roles(clave_modulo,this.current_user.permisos);  
  }

}


@Component({
  selector: 'integrations-tab-1',
  templateUrl: './integrations-tab-1.html',
  styleUrls: ['./integrations.component.scss']

})
export class IntegrationsTab1 implements AfterViewInit {

  displayedColumns: string[] = [
                                  'id', 
                                  'fecha_emision', 
                                  'match_by',
                                  'create_item_if_match_not_found',
                                  'fecha_vencimiento', 
                                  'credenciales',
                                  'sincronizar_inventario',
                                  'sincronizar_ordenes'
                                ];
  entradaDatabase: EntradaDatabase | null;
  data: EntradaIssue[] = [];

  resultsLength      = 0;
  isLoadingResults   = true;
  isRateLimitReached = false;
  guiaForm           : FormGroup;
  keywords           = "";
  current_user       : any;


  constructor(
      private formBuilder: FormBuilder,
      private _httpClient: HttpClient,
      public dialog: MatDialog,
      private invoiceService: InvoiceService,
      private authenticationService: AuthenticationService,
      private sellerDisconnectService: SellerDisconnectService,
      private snackbar: MatSnackBar
  ) { }

  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort: MatSort;



  ngAfterViewInit() {


    this.entradaDatabase = new EntradaDatabase(this._httpClient);

    // If the user changes the sort order, reset back to the first page.
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

    // console.log("las keywords iniciales son " + this.keywords)
    this.hacerTabla(this.keywords);
  


  }
  ngOnInit() {
    this.asignarDatos();
  }
  asignarDatos(){
    this.current_user = this.authenticationService.currentUserValue
    
  }
  validar_roles(clave_modulo){
    return this.authenticationService.validar_roles(clave_modulo,this.current_user.permisos);  
  }

  descargarInvoice(tipo, invoice_id){
    // console.log("vamos a descargar el invoice en " + tipo)
    this.invoiceService.invoice_url(invoice_id, tipo)
    .pipe(first())
    .subscribe(
      data => {
        // console.log("la data es");
        // console.log(data);
        // console.log(data.status)
        // console.log(data.body["url"]);
        window.open(data.body["url"]);
      },
      error => {
       // this.error = error;
       // this.loading = false;
       // this.spinner = false;
    });
  }

  setClasses() {
    
   
    let myClasses = {
     // retrasado: Date.parse(fecha_corte.toISOString()) > Date.parse(fecha_creado),
     // a_tiempo: Date.parse(fecha_corte.toISOString()) < Date.parse(fecha_creado),
    }

    return  myClasses
  }

  hacerTabla(filtros){
    merge(this.sort.sortChange, this.paginator.page, )
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          return this.entradaDatabase!.getRepoIssues(
            this.sort.active, this.sort.direction, this.paginator.pageIndex, filtros);
        }),
        map(data => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsLength = data.total_count;
          // console.log("vamos en la 72")
          // console.log(data)
         

          return data.items;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          // Catch if the GitHub API has reached its rate limit. Return empty data.
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      ).subscribe(data => this.data = data);
  }

  openDialogLiverpool(platform){
    // // console.log(platform) Liverpool  Api Marketful
    // console.log("Entro a dialog guia")

    //// console.log(correo)
    if(platform == "Liverpool"){
      const dialogRef = this.dialog.open(DialogIntegration ,{width:'450px', height: 'auto', data: {}});

      dialogRef.afterClosed().subscribe(result => {
        // console.log("Cerramos el dialog");
      });
    } else if(platform == "Ventiapp"){
      const dialogRef = this.dialog.open(DialogIntegration4 ,{width:'450px', height: 'auto', data: {}});

      dialogRef.afterClosed().subscribe(result => {
        this.hacerTabla(this.keywords);
      });
    } else if(platform == "Elenas"){
      const dialogRef = this.dialog.open(DialogIntegration5 ,{width:'450px', height: 'auto', data: {}});

      dialogRef.afterClosed().subscribe(result => {
        // this.hacerTabla(this.keywords);
      });
    } else if(platform == "Odoo"){
      const dialogRef = this.dialog.open(DialogIntegration6 ,{width:'450px', height: 'auto', data: {}});

      dialogRef.afterClosed().subscribe(result => {
        this.hacerTabla(this.keywords);
      });
    } else{
      const dialogRef = this.dialog.open(DialogIntegration2 ,{width:'450px', height: 'auto', data: {}});

      dialogRef.afterClosed().subscribe(result => {
        // console.log("Cerramos el dialog");
      });
    }
    
  }

  desvincularCuenta(){
    const dialogRef = this.dialog.open(DialogIntegration3 ,{width:'450px', height: 'auto', data: {}});
  }
  //  PARA DIALOGO GUIAS
  // openDialog(entrada_token) {
  //   // console.log("Entro a dialog guia")

  //   //// console.log(correo)
  //   const dialogRef = this.dialog.open(DialogIntegration ,{width:'450px', height: 'auto', data: {token: entrada_token}});

  //   dialogRef.afterClosed().subscribe(result => {
  //     // console.log("Cerramos el dialog");
  //     this.hacerTabla(this.keywords);
  //   });
  // }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.keywords = filterValue.trim().toLowerCase();
    // console.log("las keywords son ")
    // console.log(this.keywords)
    this.hacerTabla(this.keywords);
  }

  async disconnectPlatform(platform){

    if(platform.liga_desconexion && platform.status === 'Conectado'){
      location.replace(platform.liga_desconexion)
      return;
    }

    this.dialog.open(DialogConfirmationComponent,{
      data: `¿Estas seguro de desconectar ${platform.platform}?`
    }).afterClosed()
    .subscribe(async(confirm: Boolean) => {
      if(confirm){
       if (platform.platform === 'Elenas' && platform.status === 'Conectado'){
          try {
            platform.is_loading = true;
            await this.sellerDisconnectService.disconnectElenas()
            this.snackbar.open("Desconexión con exito", "OK", {                      
              duration: 5000,
              verticalPosition: 'top',
              horizontalPosition: 'end',
              panelClass: ['alert-green']
            });  
            setTimeout(() => {
              location.reload()
            }, 500);
          } catch (error) {
            this.snackbar.open("Ocurrió un error", "OK", {                      
              duration: 5000,
              verticalPosition: 'top',
              horizontalPosition: 'end',
              panelClass: ['alert-red']
            });  
          }finally{
            platform.is_loading = false;
          }
        } else if(platform.platform === 'Liverpool' && platform.status === 'Conectado'){
          try {
            platform.is_loading = true;
            await this.sellerDisconnectService.disconnectLiverpool()
            this.snackbar.open("Desconexión con exito", "OK", {                      
              duration: 5000,
              verticalPosition: 'top',
              horizontalPosition: 'end',
              panelClass: ['alert-green']
            });  
            setTimeout(() => {
              location.reload()
            }, 500);
          } catch (error) {
            this.snackbar.open("Ocurrió un error", "OK", {                      
              duration: 5000,
              verticalPosition: 'top',
              horizontalPosition: 'end',
              panelClass: ['alert-red']
            });  
          }finally{
            platform.is_loading = false;
          }
        }
      }

    })
  }
  // funcion para sincronizar inventarios y sincronizar ordenes
  async sincronizar_inventarios(platform){ 
    this.dialog.open(DialogConfirmationComponent,{
      data: `¿Estas seguro de sincronizar inventario de  ${platform.platform}?`
    }).afterClosed()
    .subscribe(async(confirm: Boolean) => {
      if(confirm){ 
          try { 
            await this.sellerDisconnectService.sincronizaInventario(this.current_user.seller_id,platform.platform)
            this.snackbar.open("La sincronización ha empezado, esto puede demorar...", "OK", {                      
              duration: 5000,
              verticalPosition: 'top',
              horizontalPosition: 'end',
              panelClass: ['alert-green']
            });  
            setTimeout(() => {
              // location.reload()
            }, 500);
          } catch (error) {
            this.snackbar.open("No se encontro una conexión", "OK", {                      
              duration: 5000,
              verticalPosition: 'top',
              horizontalPosition: 'end',
              panelClass: ['alert-red']
            });  
          }finally{
             
          }
           
      }

    })
  }

  async sincronizar_ordenes(platform){ 
    this.dialog.open(DialogConfirmationComponent,{
      data: `¿Estas seguro de sincronizar ordenes de  ${platform.platform}?`
    }).afterClosed()
    .subscribe(async(confirm: Boolean) => {
      if(confirm){ 
          try { 
            await this.sellerDisconnectService.sincronizaOrdenes(this.current_user.seller_id,platform.platform)
            this.snackbar.open("La sincronización ha empezado, esto puede demorar...", "OK", {                      
              duration: 5000,
              verticalPosition: 'top',
              horizontalPosition: 'end',
              panelClass: ['alert-green']
            });  
            setTimeout(() => {
              // location.reload()
            }, 500);
          } catch (error) {
            this.snackbar.open("Ocurrió un error", "OK", {                      
              duration: 5000,
              verticalPosition: 'top',
              horizontalPosition: 'end',
              panelClass: ['alert-red']
            });  
          }finally{
             
          } 
      }

    })
  }

}

export interface EntradabApi {
  items: EntradaIssue[];
  total_count: number;
}

export interface EntradaIssue {
  created_at: string;
  number: string;
  state: string;
  title: string;
}

/** An example database that the data source uses to retrieve data for the table. */
export class EntradaDatabase {
  constructor(private _httpClient: HttpClient) {}

  getRepoIssues(sort: string, order: string, page: number, filtro: string): Observable<EntradabApi> {
    // console.log(sort)
    // console.log(order)
    // console.log(page)
     const href = `${environment.apiUrl}/rmsfe/query_integrations.json`;
    const requestUrl =
        `${href}?sort=${sort}&order=${order}&page=${page + 1}&keywords=${filtro}`;

    return this._httpClient.get<EntradabApi>(requestUrl);
  }
}



@Component({
  selector: 'integrations-tab-2',
  templateUrl: './integrations-tab-2.html',
  styleUrls: ['./integrations.component.scss']

})
export class IntegrationsTab2 implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}


@Component({
  selector: 'integrations-tab-3',
  templateUrl: './integrations-tab-3.html',
  styleUrls: ['./integrations.component.scss']

})
export class IntegrationsTab3 implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}


@Component({
  selector: 'dialog-integration',
  templateUrl: './dialog-integration.html',
})
export class DialogIntegration {

  hacer_match_con: "";
  hacerMatchCon: FormControl;
  match_options: string[] = ['SKU', 'EAN'];
  guiaForm: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;
  error: string;
  la_guia: string;
  mensaje_success = false;
  guiaFormApiKey: FormControl;
  guiaFormApiKeyGuiasPropias: FormControl;
  guiaFormApiIdMirakl: FormControl;
  spinner = false;
  entrada_token: string;
  keywords = "";
  otra = false;
  paqueteria: string;
  liverpool_key = "";
  liverpool_key_guias_externas = "";
  id_mirakl = ""
  hide = true;
  hide2 = true;
  key_original = "";
  guias_propias = false;
  crear_producto_sin_match = false;

  constructor(
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<DialogIntegration>,
    private entradaService: EntradaService,
    private inventarioService: InventarioService,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any
    ){
      this.consultarCredenciales();
    }

  consultarCredenciales(){
    this.spinner = true;
    this.inventarioService.consultarAPiLiverpool()
    .pipe(first())
    .subscribe(
      data => {
        // console.log("Consultar es")
        // console.log(data["result"])
        // console.log(data.status)
        if(data.status == 200){
          this.liverpool_key = data.body["result"]["liverpool_key"];
          this.key_original = data.body["result"]["liverpool_key"];

          if (data.body["result"]["guias_propias_liverpool"]){
            this.guias_propias = true;
          }else{
            this.guias_propias = false;
          }

          if (data.body["result"]["liverpool_crear_producto_sin_match"]){
            this.crear_producto_sin_match = true;
          }else{
            this.crear_producto_sin_match = false;
          }

          this.liverpool_key_guias_externas = data.body["result"]["liverpool_key_guias_externas"];
          this.id_mirakl = data.body["result"]["id_mirakl"];
          this.hacer_match_con = data.body["result"]["liverpool_match_product_by"];
          this.hacerMatchCon.setValue(this.hacer_match_con);
        }
        this.spinner = false;
      },
      error => {
   });
  }

  ngOnInit(){
    this.guiaForm = this.formBuilder.group({
      guiaFormGuia: ['', Validators.required],
    });
    this.guiaFormApiKey = new FormControl('', [] );
    this.guiaFormApiKeyGuiasPropias = new FormControl('', [] );
    this.guiaFormApiIdMirakl = new FormControl('', [] );
    this.hacerMatchCon = new FormControl('', [] );
  }

  guardarApiKey(){
    if(!this.guias_propias){
      this.liverpool_key_guias_externas = "";
      this.id_mirakl = "";
    }else{

      if(this.hacerMatchCon.value == null){
        this.snackBar.open("Debe seleccionar el valor con el que se hará Match con los Productos de Marketful", "OK", {                      
          duration: 4000,
        });
        return false;
      }
      if(this.guiaFormApiKeyGuiasPropias.value == null || this.guiaFormApiKeyGuiasPropias.value.replace(/ /g, "") == ""){
        this.snackBar.open("ES OBLIGATORIO EL CAMPO API KEY LIVERPOOL GUÍAS PROPIAS", "OK", {                      
          duration: 4000,
        });
        return false;
      }
      if(this.guiaFormApiIdMirakl.value == null || this.guiaFormApiIdMirakl.value.replace(/ /g, "") == ""){
        this.snackBar.open("ES OBLIGATORIO EL CAMPO ID MIRAKL", "OK", {                      
          duration: 4000,
        });
        return false;
      }
    }
    this.loading = true;
    this.spinner = true;
    this.inventarioService.actualizarApiLiverpool(this.guiaFormApiKey.value, this.guiaFormApiKeyGuiasPropias.value, this.guias_propias, this.guiaFormApiIdMirakl.value, this.hacerMatchCon.value, this.crear_producto_sin_match)
    .pipe(first())
    .subscribe(
      data => {
        // console.log("actualizar")
        // console.log(data["message"])
        // console.log(data)
        // console.log(data.status)
        if(data["result"] == 200){
          this.mensaje_success = true;
          this.loading = false;
          this.spinner = false;
          
          this.snackBar.open(data["message"], "OK", {                      
            duration: 4000,
          });
          // this.dialogRef.close();
        }
      },
      error => {
   });
  }

}





@Component({
  selector: 'dialog-integration-2',
  templateUrl: './dialog-integration-2.html',
})
export class DialogIntegration2 {

  guiaForm: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;
  error: string;
  la_guia: string;
  mensaje_success = false;
  guiaFormApiUser: FormControl;
  guiaFormApiToken: FormControl;
  spinner = false;
  entrada_token: string;
  keywords = "";
  otra = false;
  paqueteria: string;
  api_user = "";
  api_token = "";
  hide = true;
  hide2 = true;
  cambio_key = true;

  constructor(
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<DialogIntegration2>,
    private entradaService: EntradaService,
    private inventarioService: InventarioService,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any
    ){
    
    this.consultarCredenciales();
  }

  consultarCredenciales(){
    this.spinner = true;
    this.inventarioService.consultarAPiMKTF()
    .pipe(first())
    .subscribe(
      data => {
        // console.log("Consultar es")
        // console.log(data["result"])
        // console.log(data.status)
        if(data.status == 200){
          this.api_user = data.body["result"][0];
          this.api_token = data.body["result"][1];
        }
        this.spinner = false;
      },
      error => {
   });
  }

  ngOnInit(){
    this.guiaForm = this.formBuilder.group({
      guiaFormGuia: ['', Validators.required],
    });
    this.guiaFormApiUser = new FormControl('', [] );
    this.guiaFormApiToken = new FormControl('', [] );
  }


  guardarApiKey(){
    
    this.loading = true;
    this.spinner = true;

    this.inventarioService.actualizarApiMKTF()
    .pipe(first())
    .subscribe(
      data => {
        // console.log("actualizar")
        // console.log(data["message"])
        // console.log(data)
        // console.log(data.status)
        if(data["result"] == 200){
          this.mensaje_success = true;
          this.loading = false;
          this.spinner = false;
          this.consultarCredenciales();
          this.snackBar.open(data["message"], "OK", {                      
            duration: 4000,
          });
          // this.dialogRef.close();
        }
      },
      error => {
   });
  }

}


@Component({
  selector: 'dialog-integration-4',
  templateUrl: './dialog-integration-4.html',
})
export class DialogIntegration4 {

  guiaForm: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;
  error: string;
  la_guia: string;
  mensaje_success = false;
  formApiUserVenti: FormControl;
  formApiPassVenti: FormControl;
  spinner = false;
  entrada_token: string;
  keywords = "";
  otra = false;
  paqueteria: string;
  api_user = "";
  api_token = "";
  hide = true;
  hide2 = true;
  cambio_key = true;

  constructor(
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<DialogIntegration4>,
    private inventarioService: InventarioService,
    @Inject(MAT_DIALOG_DATA) public data: any
    ){
    
    this.consultarCredenciales();
  }

  consultarCredenciales(){
    this.spinner = true;
    this.inventarioService.consultarApiVentiapp()
    .pipe(first())
    .subscribe(
      data => {
        if(data.status == 200){
          this.api_user = data.body["result"][0];
          this.api_token = data.body["result"][1];
        }
        this.spinner = false;
      },
      error => {
   });
  }

  ngOnInit(){
    this.guiaForm = this.formBuilder.group({
      guiaFormGuia: ['', Validators.required],
    });
    this.formApiUserVenti = new FormControl('', [] );
    this.formApiPassVenti = new FormControl('', [] );
  }


  guardarApiVentiKey(){
    
    this.loading = true;
    this.spinner = true;

    this.inventarioService.actualizarApiVentiapp(this.formApiUserVenti.value, this.formApiPassVenti.value)
    .pipe(first())
    .subscribe(
      data => {
        if(data["result"] == 200){
          this.mensaje_success = true;
          this.loading = false;
          this.spinner = false;
          this.consultarCredenciales();
          this.snackBar.open(data["message"], "OK", {                      
            duration: 4000,
          });
        }else{
          this.loading = false;
          this.spinner = false;
          this.snackBar.open(data["message"], "OK", {                      
            duration: 4000,
          });
        }
      },
      error => {
   });
  }

}


@Component({
  selector: 'dialog-integration-5',
  templateUrl: './dialog-integration-5.html',
})
export class DialogIntegration5 {

  guiaForm: FormGroup;
  loading = false;
  error: string;
  guiaFormApiToken: FormControl;
  spinner = false;
  api_token = "";
  hide = true;
  hide2 = true;
  crear_producto_sin_match = false;

  constructor(
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<DialogIntegration5>,
    private inventarioService: InventarioService,
    @Inject(MAT_DIALOG_DATA) public data: any
    ){
    
    this.consultarCredenciales();
  }

  consultarCredenciales(){
    this.spinner = true;
    this.inventarioService.consultarApiElenas()
    .pipe(first())
    .subscribe(
      data => {
        if(data.status == 200){
          this.api_token = data.body["result"][0];
          this.crear_producto_sin_match = data.body["result"][1];
        }
        this.spinner = false;
      },
      error => {
   });
  }

  ngOnInit(){
    this.guiaForm = this.formBuilder.group({
      guiaFormGuia: ['', Validators.required],
    });
    this.guiaFormApiToken = new FormControl('', [] );
  }

  guardarApiElenas(){
    
    this.loading = true;
    this.spinner = true;

    this.inventarioService.actualizarApiElenas(this.guiaFormApiToken.value, this.crear_producto_sin_match)
    .pipe(first())
    .subscribe(
      data => {
        if(data["result"] == 200){
          this.loading = false;
          this.spinner = false;
          this.consultarCredenciales();
          this.dialogRef.close();
          this.snackBar.open(data["message"], "OK", {                      
            duration: 4000,
          });
        }else{
          this.loading = false;
          this.spinner = false;
          this.snackBar.open(data["message"], "OK", {                      
            duration: 4000,
          });
        }
      },
      error => {
   });
  }

}


@Component({
  selector: 'dialog-integration-3',
  templateUrl: './dialog-integration-3.html',
})
export class DialogIntegration3 {

  guiaForm: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;
  error: string;
  la_guia: string;
  mensaje_success = false;
  guiaFormApiUser: FormControl;
  guiaFormApiToken: FormControl;
  spinner = false;
  entrada_token: string;
  keywords = "";
  otra = false;
  paqueteria: string;
  api_user = "";
  api_token = "";
  hide = true;
  hide2 = true;
  cambio_key = true;
  opcion_desvincular = "";

  constructor(
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<DialogIntegration3>,
    private entradaService: EntradaService,
    private shopifyService: ShopifyService,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any
    ){
    
  }

  ngOnInit(){
    
  }


  desvincularCuenta(opcion){
    if(opcion == 1){
      this.opcion_desvincular = "no_borrar"
    }else{
      this.opcion_desvincular = "borrar"
    }
    this.loading = true;
    this.spinner = true;
    // console.log("opcion es "+this.opcion_desvincular)
    this.shopifyService.desvincularShopify(this.opcion_desvincular)
    .pipe(first())
    .subscribe(
      data => {
        if(data["result"] == 200){
          this.mensaje_success = true;
          this.loading = false;
          this.spinner = false;
          this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
            this.router.navigate(['/integrations']);
          }); 
          this.snackBar.open("Cuenta desvinculada", "OK", {                      
            duration: 4000,
          });
          this.dialogRef.close();
        }
      },
      error => {
   });
  }

}
@Component({
  selector: 'dialog-integration-6',
  templateUrl: './dialog-integration-6.html',
})
export class DialogIntegration6 {
  guiaFormOdoo: FormGroup;
  formApiUserOdoo: FormControl;
  api_user_odoo = "";
  formApiUrlOdoo: FormControl;
  api_url_odoo = "";
  formApiBdOdoo: FormControl;
  api_bd_odoo = "";
  formPassUserOdoo: FormControl;
  api_pass_odoo = "";
  datos_envio: object;
  hide_pass = true;
  btn_disabled = false;
  spinner = false;
  match_options: string[] = ['SKU', 'EAN'];
  hacer_match_con: "";
  hacerMatchCon: FormControl;
  crear_producto_sin_match = false;
  hide_key = true;
  formKeyUserOdoo: FormControl;
  api_key_odoo = "";
  error: string;

  constructor(
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<DialogIntegration5>,
    private entradaService: EntradaService,
    private inventarioService: InventarioService,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any
    ){
      this.consultarCredencialesOdoo();
    }

  ngOnInit(){
    this.guiaFormOdoo = this.formBuilder.group({
      
    });
    this.formApiUrlOdoo = new FormControl('', [Validators.required]);
    this.formApiUserOdoo = new FormControl('', [Validators.required]);
    this.formApiBdOdoo = new FormControl('', [Validators.required]);
    this.formPassUserOdoo = new FormControl('', [Validators.required]);
    this.hacerMatchCon = new FormControl('', [Validators.required] );
    this.formKeyUserOdoo = new FormControl('', []);
  }

  consultarCredencialesOdoo(){
    this.spinner = true;
    this.inventarioService.consultarApiOdoo()
    .pipe(first())
    .subscribe(
      data => {
        if(data.status == 200){
          this.api_user_odoo = data.body["result"]["user_name"];
          this.api_url_odoo = data.body["result"]["url"];
          this.api_bd_odoo = data.body["result"]["db"];
          this.api_pass_odoo = data.body["result"]["password"];
          this.hacer_match_con = data.body["result"]["match_product_by"];
          this.api_key_odoo = data.body["result"]["api_key"];
          if (data.body["result"]["crear_producto_sin_match"]){
            this.crear_producto_sin_match = true;
          }else{
            this.crear_producto_sin_match = false;
          }
        }
        this.spinner = false;
      },
      error => {
   });
  }

  guardar_editar_api_key_odoo(){
    this.btn_disabled = true;

    if(this.hacer_match_con == ""){
      this.snackBar.open("Debe seleccionar el valor con el que se hará Match con los Productos de Odoo", "OK", {                      
        duration: 4000,
      });
      this.btn_disabled = false;
      return false;
    }

    if(this.formApiUserOdoo.invalid || this.formPassUserOdoo.invalid || this.formApiUrlOdoo.invalid || this.formApiBdOdoo.invalid){
        this.btn_disabled = false;
        return;
    }

    this.datos_envio = {
      url: this.formApiUrlOdoo.value,
      bd: this.formApiBdOdoo.value,
      usuario: this.formApiUserOdoo.value,  
      pass: this.formPassUserOdoo.value,
      crear_sin_match: this.crear_producto_sin_match,
      match: this.hacer_match_con,
      key: this.formKeyUserOdoo.value,
    };
    this.spinner = true;

    this.inventarioService.actualizarApiOdoo(this.datos_envio)
    .pipe(first())
    .subscribe(
      data => {
        if(data["status"] == 200){
          this.spinner = false;
          this.btn_disabled = false;
          this.dialogRef.close();
          this.snackBar.open(data["message"], "OK", {                      
            duration: 5000,
          });
          this.consultarCredencialesOdoo();
        }else{
          this.snackBar.open(data["message"], "OK", {                      
            duration: 5000,
          });
          this.spinner = false;
          this.btn_disabled = false;
        }
      },
      error => {
        this.spinner = false;
        this.btn_disabled = false;
    });

  }

}